import { ContentContext, LocaleContext, RegionContext } from 'Components/hooks/context';
import React, { useContext } from 'react';

import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import SmartText from '@reuters-graphics/react-smart-text';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import { roundDownSmart } from 'Utils/roundDown';

const atlas = new AtlasMetadataClient();

const TopDailyHeadline = (props) => {
  const { regionalCounts } = props;

  const locale = useContext(LocaleContext);
  const regionSlug = useContext(RegionContext);
  const content = useContext(ContentContext).template.dailyCounts;

  const region = atlas.getRegion(regionSlug);

  const cases = roundDownSmart(regionalCounts.cases.reduce((a, d) => a + d.count, 0));
  const deaths = roundDownSmart(regionalCounts.deaths.reduce((a, d) => a + d.count, 0));

  return (
    <div className={classnames(component)}>
      <div className='section-spacer' />
      <div>
        <h2>
          <SmartText
            source={content.title}
            context={{
              region: region.translations[locale],
            }}
          />
        </h2>
        <SmartText
          source={content.intro}
          context={{
            deaths: (
              <span className='highlight' key='deaths'>
                {deaths.toLocaleString(locale)}
              </span>
            ),
            cases: (
              <span className='highlight' key='cases'>
                {cases.toLocaleString(locale)}
              </span>
            ),
            region: region.translations[locale],
          }}
          wrap
        />
      </div>
    </div>
  );
};

export default TopDailyHeadline;
